<template>
  <div class="d-flex flex-1-1">
    <nav class="d-flex flex-0-0 fd-column w-100">
      <vk-carousel ref="carousel" arrows-hidden snap-disabled>
        <component
            v-for="tab in tabs"
            v-bind="tab.titleProps"
            :is="tab.titleComponent"
            :ref="tab.name"
            :key="tab.name"
            :name="tab.name"
            :class="{'DISABLED' : disabled}"
            :active="tab.active || tab.name === activeTab"
            @click.native="onClick({ name: tab.name })"
        />
        <span
            class="HIGHLIGHT"
            :style="{ left: `${highlightLeft}px`, width: `${highlightWidth}px` }"
        />
      </vk-carousel>
    </nav>
    <slot :activeTab="{ activeTab }" />
  </div>
</template>

<script>
import SlidingTabsTitle from './SlidingTabsContent/SlidingTabsTitle';

export default {
  name: 'sliding-tabs',
  components: {
    SlidingTabsTitle,
  },
  props: {
    activeTab: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tabs: [],
      highlightLeft: 0,
      highlightWidth: 0,
    };
  },
  created () {
    this.tabs = this.$children;
  },
  updated () {
    this.moveHighlight();
  },
  methods: {
    moveHighlight () {
      const tabRef = this.$refs[this.activeTab];
      const carouselRef = this.$refs.carousel;

      if (!tabRef || !carouselRef) {
        return;
      }

      const carouselContent = carouselRef.$content;
      const tab = Array.isArray(tabRef) ? tabRef[0].$el : tabRef;
      const { left: parentLeft } = carouselContent.getBoundingClientRect();
      const { left, width } = tab.getBoundingClientRect();
      const relativeLeft = left - parentLeft;

      this.highlightLeft = carouselContent.scrollLeft + relativeLeft;
      this.highlightWidth = width;

      if (
        relativeLeft + width > carouselContent.offsetWidth
        || relativeLeft < carouselContent.scrollLeft
      ) {
        carouselRef.scrollToOffset(relativeLeft);
      }
    },
    onClick (data) {
      this.$emit('change', data);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .DISABLED {
    pointer-events: none;
  }
  .HIGHLIGHT {
    @include absolute(auto, auto, 0, 0);
    height: 3px;
    background-color: $color-depot;
    will-change: left, width;
    transition: left $transition-half-duration, width $transition-half-duration;
  }
</style>
